import Vue from "vue";
import vuex from "vuex";
Vue.use(vuex);
import home from "./modules/home";
import service from "./modules/service";
import agency from "./modules/agency";
import user from "./modules/user";
import globel from "./modules/globel";

const modules = {
  home,
  service,
  agency,
  user,
  globel
};

const store = new vuex.Store({
  modules
});

export default store;
